import clsx from "clsx";
import type { PropsWithChildren } from "react";

interface IProps extends PropsWithChildren {
  className?: string;
  onClick?: () => void;
  align?: "start" | "center" | "end";
  id?: string;
}

const TableCell = ({ children, className, onClick, align = "center", id }: IProps) => {
  return (
    <div
      className={clsx(
        "flex w-full items-center truncate px-2-5 py-0!",
        onClick && "cursor-pointer",
        className,
        align === "start" && "justify-start",
        align === "center" && "justify-center",
        align === "end" && "justify-end",
      )}
      onClick={onClick}
      id={id}
    >
      {children}
    </div>
  );
};

export default TableCell;
